var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonaStrzalka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    display: "block",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 27.5 27.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--stroke-0, white)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.292,
    d: "M5.73 13.75h16.04m-8.02-8.02 8.02 8.02-8.02 8.02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonaStrzalka);
export default __webpack_public_path__ + "static/media/ikona-strzalka.015dbff846472dc6e2bfc87feaf25edf.svg";
export { ForwardRef as ReactComponent };